import {
  Button,
  Col,
  Divider,
  Input,
  Modal,
  Select,
  DatePicker,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import "./DealerProfile.scss";
import moment from "moment";
import { useHistory } from "react-router-dom";

var axios = require("axios");

const DealerProfile = (props: { location: { state?: any } }) => {
  var history = useHistory();
  const getcustomer = props.location.state;
  const [customerDetails, setCustomerDetails] = useState({
    firstName: "",
    mobile: "",
    email: "",
    externalId: "",
    bankAccountNumber: "",
    bankName: "",
    branchCode: "",
    dateOfBirth: "",
    company: "",
    area: "",
    associatedStaff: "",
    userId: "",
    identifierEmail: {},
    identifierMobile: {},
    identifierExternalId:{},
    isActive: "",
  });
  const [isToastVisible, setisToastVisible] = useState(false);
  const [toastText, setToastText] = useState("");
  const [showLoading, setshowLoading] = useState(false);
  const [storeList, setStoreList] = useState<any[]>([]);
  const [getActive, setActive] = useState(false);

  const handleOkToast = () => {
    setisToastVisible(false);
  };
  const cancelToast = () => {
    setisToastVisible(false);
  };

  const handleCustomerDetailsChange =
    (name: string) => (event: { target: { value: any } }) => {
      if (name === "email") {
        let email = {
          oldEmail: getcustomer.data.email,
          newEmail: event.target.value.trim(),
        };
        if (getcustomer.data.email === event.target.value.trim()) {
          setCustomerDetails({
            ...customerDetails,
            [name]: event.target.value,
            identifierEmail: {},
          });
        } else {
          setCustomerDetails({
            ...customerDetails,
            [name]: event.target.value,
            identifierEmail: email,
          });
        }
      } else if (name === "mobile") {
        let mobile = {
          oldMobile: getcustomer.data.mobile,
          newMobile: event.target.value.trim(),
        };
        if (getcustomer.data.mobile === event.target.value.trim()) {
          setCustomerDetails({
            ...customerDetails,
            [name]: event.target.value,
            identifierMobile: {},
          });
        } else {
          setCustomerDetails({
            ...customerDetails,
            [name]: event.target.value,
            identifierMobile: mobile,
          });
        }
      } else {
        setCustomerDetails({ ...customerDetails, [name]: event.target.value });
      }
    };

  useEffect(() => {
    setshowLoading(true);
    if (getcustomer.key !== null && getcustomer.key === "search") {
      const user = getcustomer.data;
      const dob = user.extended_fields.field.find((o: any) => o.name === "dob");
      const area = user.extended_fields.field.find(
        (o: any) => o.name === "area"
      );
      const company = user.extended_fields.field.find(
        (o: any) => o.name === "company"
      );
      const associatedStaff = user.extended_fields.field.find(
        (o: any) => o.name === "preferred_cashier"
      );
      const bank_account_number = user.custom_fields.field.find(
        (o: any) => o.name === "bank_account_number"
      );
      const branch_code = user.custom_fields.field.find(
        (o: any) => o.name === "branch_code"
      );
      const bank_Name = user.custom_fields.field.find(
        (o: any) => o.name === "bank_and_branch_name"
      );
      const is_active = user.custom_fields.field.find(
        (o: any) => o.name === "is_active"
      );

      if (is_active?.value === "true") {
        setActive(true);
      } else {
        setActive(false);
      }

      setCustomerDetails((customerDetails) => ({
        ...customerDetails,
        firstName: user.firstname,
        mobile: user.mobile,
        email: user.email,
        externalId: user.external_id,
        bankAccountNumber: bank_account_number?.value ?? "",
        bankName: bank_Name?.value ?? "",
        branchCode: branch_code?.value ?? "",
        dateOfBirth: dob?.value ?? "",
        company: company?.value ?? "",
        area: area?.value ?? "",
        associatedStaff: associatedStaff?.value ?? "",
        userId: user.user_id,
        isActive: is_active?.value ?? false,
      }));
      setshowLoading(false);
    } else {
      setCustomerDetails((customerDetails) => ({
        ...customerDetails,
        mobile: getcustomer.data,
        isActive: "true",
      }));
      setActive(true);
      setshowLoading(false);
    }
    getStoreList();
  }, [getcustomer.data, getcustomer.key]);

  const selectStore = (value: any) => {
    let external_Id = {
      oldExternalId: getcustomer.data.external_id,
      newExternalId: value,
    };
    if (getcustomer.data.external_id === value) {
      setCustomerDetails({ ...customerDetails, identifierExternalId: {} });
    } else {
      setCustomerDetails({
        ...customerDetails,
        identifierExternalId: external_Id,
        externalId: value,
      });
    }
  };

  const getStoreList = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_DEALER_BASE_URL + "stores",
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config).then((response: any) => {
      setStoreList(response.data.storeData);
    });
  };

  const StoreOptions =
    storeList &&
    storeList.map((data: any) => {
      return { value: data.external_id, label: data.external_id };
    });

  function Validate(customerDetails: any) {
    if (customerDetails.firstName.trim() !== "" && customerDetails.firstName.match(/^[a-zA-Z _]+$/)) {
      if (customerDetails.externalId && customerDetails.externalId !== "") {
        if (customerDetails.dateOfBirth !== "") {
          if (/^([0-9]{8})\d+$/.test(customerDetails.mobile)) {
            if (
              (customerDetails.mobile.startsWith("84", 0) &&
                customerDetails.mobile.length < 13) ||
              customerDetails.mobile.length < 11
            ) {
              if (
                (customerDetails.bankAccountNumber &&
                  /^\d+$/.test(customerDetails.bankAccountNumber)) ||
                customerDetails.bankAccountNumber === ""
              ) {
                if (
                  /^[a-zA-Z _]*$/.test(customerDetails.bankName) ||
                  customerDetails.bankName === ""
                ) {
                  if (
                    !/[^0-9a-zA-Z]/.test(customerDetails.branchCode) ||
                    customerDetails.branchCode === ""
                  ) {
                    if (
                      /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(
                        customerDetails.email
                      ) ||
                      customerDetails.email === ""
                    ) {
                      return true;
                    } else {
                      setToastText("Invalid email");
                      setisToastVisible(true);
                      return false;
                    }
                  } else {
                    setToastText("Invalid characters in branch code");
                    setisToastVisible(true);
                    return false;
                  }
                } else {
                  setToastText("Bank name should contain only alphabets");
                  setisToastVisible(true);
                  return false;
                }
              } else {
                setToastText("Bank Account number should contain only numbers");
                setisToastVisible(true);
                return false;
              }
            } else {
              setToastText("Invalid mobile number");
              setisToastVisible(true);
              return false;
            }
          } else {
            setToastText("Mobile number should contain only numbers");
            setisToastVisible(true);
            return false;
          }
        } else {
          setToastText("Date of birth cannot be empty");
          setisToastVisible(true);
          return false;
        }
      } else {
        setToastText("Please select store");
        setisToastVisible(true);
        return false;
      }
    } else {
      setToastText("Please enter proper dealer's firstname");
      setisToastVisible(true);
      return false;
    }
  }

  const handleCustomerUpdate = () => {
    if (Validate(customerDetails)) {
      if (getcustomer.key !== "search") {
        var config = {
          method: "post",
          url: process.env.REACT_APP_DEALER_BASE_URL + "customer/signup",
          headers: {
            "Content-Type": "application/json",
          },
          data: customerDetails,
        };
        setshowLoading(true);
        axios(config)
          .then((response: any) => {
            setshowLoading(false);
            if (response.data.status.success) {
              setToastText("Customer Added successfully");
              setisToastVisible(true);
              setshowLoading(false);
              window.setTimeout(() => history.replace("/Dealer/search"), 1000);
            } else {
              setToastText(
                "Update failed , Customer already exists for same email/store"
              );
              setisToastVisible(true);
              setshowLoading(false);
            }
          })
          .catch((error: any) => {
            setToastText("Something went wrong!!, Please try again.");
            setisToastVisible(true);
            setshowLoading(false);
          });
      } else {
        config = {
          method: "put",
          url:
            process.env.REACT_APP_DEALER_BASE_URL +
            "customer/update?mobile=" +
            customerDetails.mobile +
            "&userId=" +
            customerDetails.userId,
          headers: {
            "Content-Type": "application/json",
          },
          data: customerDetails,
        };
        setshowLoading(true);
        axios(config)
          .then((response: any) => {
            setshowLoading(false);
            if (response.data.status.success) {
              setToastText("Customer updated successfully");
              setisToastVisible(true);
              setshowLoading(false);
              window.setTimeout(() => history.replace("/Dealer/search"), 1000);
            } else {
              setToastText(
                "Update failed , Customer already exists for same mobile/email/store"
              );
              setisToastVisible(true);
              setshowLoading(false);
            }
          })
          .catch((error: any) => {
            setToastText("Something went wrong!!, Please try again.");
            setisToastVisible(true);
            setshowLoading(false);
          });
      }
    }
  };

  const disabledDate = (current: any) => {
    return current && current > moment().endOf("day");
  };

  const handleClick = (event: any) => {
    if (getcustomer.key === "search") {
      if (event.target.value === "true") {
        setActive(true);
      } else {
        setActive(false);
      }
    }
    setCustomerDetails({ ...customerDetails, isActive: event.target.value });
  };
  return (
    <div>
      <Spin tip="Loading..." spinning={showLoading}>
        <div className="customerDetailsContainer">
          <p className="title">Dealer Profile</p>

          <div className="Status">
            <button
              value={"true"}
              className={getActive ? "StatusTextActive" : "StatusTextInActive"}
              onClick={(e) => handleClick(e)}
            >
              ACTIVE
            </button>
            <button
              value={"false"}
              className={getActive ? "StatusTextInActive" : "StatusTextActive"}
              onClick={(e) => handleClick(e)}
            >
              INACTIVE
            </button>
          </div>

          <form>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>First Name</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.firstName ? customerDetails.firstName : ""
                    }
                    onChange={handleCustomerDetailsChange("firstName")}
                  />
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Bank Account Number</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.bankAccountNumber
                        ? customerDetails.bankAccountNumber
                        : ""
                    }
                    onChange={handleCustomerDetailsChange("bankAccountNumber")}
                  />
                </div>
              </Col>
            </div>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Company</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.company ? customerDetails.company : ""
                    }
                    onChange={handleCustomerDetailsChange("company")}
                  />
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Bank Name</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.bankName ? customerDetails.bankName : ""
                    }
                    onChange={handleCustomerDetailsChange("bankName")}
                  />
                </div>
              </Col>
            </div>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Storecode</label>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    value={customerDetails.externalId}
                    onChange={selectStore}
                    placeholder="Choose"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#000000",
                    }}
                    options={StoreOptions}
                  ></Select>
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Branch code</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.branchCode
                        ? customerDetails.branchCode
                        : ""
                    }
                    onChange={handleCustomerDetailsChange("branchCode")}
                  />
                </div>
              </Col>
            </div>

            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Mobile Number</label>
                  <Input
                    placeholder=""
                    value={customerDetails.mobile ? customerDetails.mobile : ""}
                    onChange={handleCustomerDetailsChange("mobile")}
                    disabled={getcustomer.key === "register" ? true : false}
                  />
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Associated Staff</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.associatedStaff
                        ? customerDetails.associatedStaff
                        : ""
                    }
                    onChange={handleCustomerDetailsChange("associatedStaff")}
                  />
                </div>
              </Col>
            </div>

            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Sale Area</label>
                  <Input
                    placeholder=""
                    value={customerDetails.area ? customerDetails.area : ""}
                    onChange={handleCustomerDetailsChange("area")}
                  />
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Email</label>
                  <Input
                    placeholder=""
                    value={customerDetails.email ? customerDetails.email : ""}
                    onChange={handleCustomerDetailsChange("email")}
                  />
                </div>
              </Col>
            </div>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Date of Birth</label>
                  <DatePicker
                    placeholder=""
                    showTime
                    format="L"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) => {
                      setCustomerDetails({
                        ...customerDetails,
                        dateOfBirth: dateString,
                      });
                    }}
                    value={
                      customerDetails.dateOfBirth
                        ? moment(customerDetails.dateOfBirth)
                        : null
                    }
                  />
                </div>
              </Col>
            </div>
            <div>
              <Button
                className="saveBtn"
                type="primary"
                onClick={handleCustomerUpdate}
              >
                Save
              </Button>
            </div>
          </form>
          <Divider></Divider>
          {/* <p className="formTitle">Transactions</p>
          <Divider></Divider> */}
          {/* {transactionsArray && (
            <Table dataSource={transactionsArray} columns={columns} />
          )} */}
        </div>
        <Modal
          title="Jotun Master Painter"
          onCancel={cancelToast}
          footer={null}
          visible={isToastVisible}
          onOk={handleOkToast}
        >
          <p>{toastText}</p>
        </Modal>
      </Spin>
    </div>
  );
};

export default DealerProfile;
